module.exports = __webpack_public_path__ + "static/media/lue_med_2.70927602.jpg";